import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { WidgetHelperService } from '../widget-helper.service';
import { CommonService } from '../../../services';

@Component({
  selector: 'column-chart',
  templateUrl: './column-chart.component.html',
  styleUrls: ['./column-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ColumnChartComponent implements OnInit {
  @Input('componentData') componentData: any;
  @Input('OffsetValue') offset: any;
  @Input('groupData') groupData: any;
  options: any;
  columnChart;
  highChartOption: any;
  constructor(private widgetHelperService: WidgetHelperService, private commonService: CommonService) { }

  ngOnChanges() {
    if (this.columnChart) {

      //Remove previous point
      for (var i = this.columnChart.series.length - 1; i >= 0; i--) {
        this.columnChart.series[i].remove();
      }

      //add new points
      this.widgetHelperService.getSeriesData(this.componentData).forEach((obj, i) => {
        // this.columnChart.series[i].remove();
        this.columnChart.addSeries(obj)
        // this.columnChart.series[i].setData(obj.data);

      });

      // this.widgetHelperService.getSeriesData(this.componentData).forEach( (obj,i)=>{
      // if(this.columnChart.series[i]){
      //   this.columnChart.series[i].update({
      //     data: obj.data
      //   }, false);
      // }
      // })
    }
  }

  ngOnInit() {

    let chartType = this.componentData.fetchDataFor;
    if (chartType == 'bar') {
      chartType = 'column';
    }

    //set default data
    this.options = {
      chart: {
        type: chartType,
        zoomType: 'x'
      },
      credits: {
        enabled: false
      },
      xAxis: this.widgetHelperService.getXAxisConfig(this.componentData, this.groupData),
      yAxis: this.widgetHelperService.getYAxisConfig(this.componentData),
      title: {
        text: ''
      },
      subtitle: {
        text: document.ontouchstart === undefined ?
          'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
      },
      plotOptions: {
        series: {
          turboThreshold: 5000,
          boostThreshold: 100,
          events: {
            legendItemClick: this.onLegendTitleClick.bind(this)
            // legendItemClick:function(){
            //   // if(this.name == 'dummy series') {
            //     debugger;
            //     if(this.visible == true){
            //         // hideBand(chart);
            //     }
            //     else {
            //         // showBand(chart);
            //     }
            //     //return false;
            // // }
            // }
          }
          // dataLabels: dataLabels
        }
      },
      series: this.widgetHelperService.getSeriesData(this.componentData),
      //ripun legend html
      legend: {
        useHTML: true,
        itemStyle: {
          textOverflow: undefined
        }
      },
    };

  }

  saveInstance(chartInstance) {
    // console.log(chartInstance);
    this.columnChart = chartInstance;
  }

  onLegendTitleClick(clickevent) {
    setTimeout(() => {
      //get all hidden legends
      let hiddenLegends = this.columnChart.legend.allItems.map(l => (!l.visible ? l.name : ""));


      this.columnChart.xAxis[0].plotLinesAndBands.forEach((pb, i) => {
        let eventId = pb.id;
        if (!eventId)
          return;
        hiddenLegends.forEach(hl => {
          eventId = eventId.replace(hl, "");
        });

        if (eventId.trim() == "e_") {
          this.columnChart.xAxis[0].plotLinesAndBands[i].hidden = true;
          this.columnChart.xAxis[0].plotLinesAndBands[i].svgElem.hide();
          this.columnChart.xAxis[0].plotLinesAndBands[i].label.hide();
        } else {
          this.columnChart.xAxis[0].plotLinesAndBands[i].hidden = false;
          this.columnChart.xAxis[0].plotLinesAndBands[i].svgElem.show();
          this.columnChart.xAxis[0].plotLinesAndBands[i].label.show();
        }
      });

      try {

        this.columnChart.update(this.columnChart);
      } catch (e) { }
    }, 5)

  }

  updatePlotBand() {

  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/column-chart/column-chart.component.ts